/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAzureCspAuthorizationCode extends models.ServiceAccountCredentialsBaseForAzureCsp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAzureCspAuthorizationCode");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAzureCspAuthorizationCode.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAzureCspAuthorizationCode>): ServiceAccountCredentialsForAzureCspAuthorizationCode {
        let obj = Object.assign(new ServiceAccountCredentialsForAzureCspAuthorizationCode(), model);
        ServiceAccountCredentialsForAzureCspAuthorizationCode.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAzureCspAuthorizationCode>): ServiceAccountCredentialsForAzureCspAuthorizationCode {
        if (!model) return null;
        return ServiceAccountCredentialsForAzureCspAuthorizationCode.newInstance(<ServiceAccountCredentialsForAzureCspAuthorizationCode> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAzureCspAuthorizationCode) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAzureCspAuthorizationCode.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAzureCspAuthorizationCode): boolean {
        if (models.ServiceAccountCredentialsBaseForAzureCsp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAzureCspAuthorizationCode.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Redirection URI. This is a required field.
     */
    redirect_uri: string;

    /**
     * Authorization Code for Token refresh. This is a required field.
     */
    authorization_code: string;

}
